import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import {
  AgentsCacheResolver,
  ClientResolver,
  CountriesResolver,
  CourseResolver,
  CoursesResolver,
  GamesColumnsResolver,
  GroupResolver,
  LocalesResolver,
  MicroFrontendResolver
} from 'core/resolvers';
import { GameResolver } from './resolvers/game.resolver';
import { MarsGroupResolver } from './resolvers/mars-group.resolver';
import { GroupStudentsScoreResolver } from './resolvers/group-students-score.resolver';
import { GroupGameResolver } from './resolvers/group-game.resolver';
import { GroupsComponent } from './groups/groups.component';
import { GroupComponent } from './group/group.component';
import { Mars1GroupComponent } from './mars1-group/mars1-group.component';

const groupsRoutes: Routes = [
  {
    path: 'groups',
    title: 'parentGroups',
    resolve: {
      countries: CountriesResolver,
      locales: LocalesResolver,
      gamesColumns: GamesColumnsResolver,
      agentsCache: AgentsCacheResolver,
      courses: CoursesResolver // For game filter
    },
    children: [
      {
        path: '',
        title: 'groups',
        component: GroupsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'groups.list' }
      },
      {
        path: 'new',
        title: 'newGroup',
        component: GroupComponent,
        resolve: {
          client: ClientResolver,
          courses: CoursesResolver
        },
        canActivate: [ProfileGuard],
        data: {
          action: 'groups.create',
          questionsDataScheme: { client: 'data.client', hasBonus: 'queryParams.hasBonus' }
        }
      },
      {
        path: 'mars',
        title: 'marsGroup',
        children: [
          {
            path: 'new',
            title: 'newMarsGroup',
            component: Mars1GroupComponent,
            resolve: {
              client: ClientResolver,
              courses: CoursesResolver
            },
            canActivate: [ProfileGuard],
            data: {
              action: 'groups.create',
              questionsDataScheme: { client: 'data.client' }
            }
          },
          {
            path: ':groupId',
            title: 'marsGroupId',
            resolve: {
              group: GroupResolver
            },
            children: [
              {
                path: '',
                title: 'marsGroupIdDetail',
                component: Mars1GroupComponent,
                canActivate: [ProfileGuard],
                resolve: {
                  client: ClientResolver,
                  course: CourseResolver,
                  game: GameResolver,
                  groupGameData: GroupGameResolver,
                  courses: CoursesResolver,
                  glreports: MicroFrontendResolver
                }
              }
            ],
            data: {
              action: 'groups.detail',
              microfrontends: ['GlReports'],
              questionsDataScheme: {
                client: 'data.client',
                group: 'data.group',
                course: 'data.course',
                groupGameData: 'data.groupGameData',
                hasBonus: 'data.group.hasBonus'
              },
              preloader: 'secondary'
            }
          }
        ]
      },
      {
        path: ':groupId',
        title: 'groupId',
        resolve: {
          group: GroupResolver
        },
        children: [
          {
            path: '',
            title: 'groupIdDetail',
            component: GroupComponent,
            canActivate: [ProfileGuard],
            resolve: {
              client: ClientResolver,
              course: CourseResolver,
              game: GameResolver,
              groupGameData: GroupGameResolver,
              courses: CoursesResolver,
              isMars: MarsGroupResolver,
              glreports: MicroFrontendResolver,
              groupStudentsScore: GroupStudentsScoreResolver
            }
          }
        ],
        data: {
          action: 'groups.detail',
          microfrontends: ['GlReports'],
          questionsDataScheme: {
            client: 'data.client',
            group: 'data.group',
            course: 'data.course',
            groupGameData: 'data.groupGameData',
            hasBonus: 'data.group.hasBonus'
          },
          preloader: 'secondary'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(groupsRoutes)],
  exports: [RouterModule]
})
export class GroupsRoutingModule {}
